import React, { Fragment } from 'react';

import { Color, FontSize, FontWeight } from '../../../typings/design-tokens';
import { teamFormation } from '../../../typings/formations';
import { slugifyCharacters } from '../../../utils/slugify';
import { makeClassNames } from '../../../utils/styles';
import Text from '../../atoms/text/text';
import Team, { ITeam, TeamLogoSize } from '../team/team';

import { getFormationLabel } from './team-header-helpers';

import './team-header.scss';

export interface ITeamHeader {
  formation: teamFormation;
  isHome?: boolean;
  team: ITeam;
}

const classNames = (isHome?: boolean, classname?: string) =>
  makeClassNames({
    teamHeader: ['team-header', isHome && 'team-header__home'],
    teamFormation: 'team-formation',
    teamFormationClass: `${classname}`,
  });

const getTeamFormation = (
  formation: teamFormation,
  classname: string,
  fontsize: FontSize,
  fontweight: FontWeight,
  color: Color
) => {
  const cn = classNames(undefined, classname);
  return (
    <Text className={cn.teamFormationClass} tag="span" fontSize={fontsize} fontWeight={fontweight} color={color}>
      {slugifyCharacters(getFormationLabel(formation))}
    </Text>
  );
};

const TeamHeader = ({ team, isHome = true, formation }: ITeamHeader) => {
  const cn = classNames(isHome);

  const COLOR: Color = 'inherit';
  const FONT_SIZE: FontSize = '18--22';
  const LOGO_SIZE: TeamLogoSize = '30';

  return (
    <Fragment>
      <div className={cn.teamHeader}>
        <Team {...team} colorSchema="dark" color={COLOR} fontSize={FONT_SIZE} logoSize={LOGO_SIZE} ellipsis />
        <span className={cn.teamFormation}>
          {formation && getTeamFormation(formation, 'team-formation-number', FONT_SIZE, '500', COLOR)}
        </span>
      </div>
    </Fragment>
  );
};

export default TeamHeader;
